import { NgModule } from "@angular/core";
import { BlinkDirective } from "./blink.directive";
import { FilePondDirective } from "./filepond.directive";
import { IFRameDocumentWriteDirective } from "./iframe-document-write.directive";
import { OverflowDetectDirective } from "./overflow-detect.directive";
import { PdfPreviewFromUrlDirective } from "./pdf-preview-from-url.directive";
import { ScrollIntoViewDirective } from "./scrollintoview.directive";
import { HtmlContentDirective } from "src/app/modules/bootstrap/directives/html-content.directive";
import { DraggableInteractDirective } from "src/app/modules/bootstrap/directives/draggable.directive";
import { TooltipDirective } from "src/app/modules/bootstrap/directives/tooltip.directive";
import { TemplateDirective } from "src/app/modules/bootstrap/directives/common/template.directive";
import { PdfThumbnailDirective } from "src/app/modules/bootstrap/directives/pdf-thumbnail.directive";
import { HostListenerDirective } from "src/app/modules/bootstrap/directives/host-listener.directive";
import { UppyDirective } from "src/app/modules/bootstrap/directives/uppy.directive";
import { ResizeObserverDirective } from "src/app/modules/bootstrap/directives/resize-observer.directive";

@NgModule({
  declarations: [
    FilePondDirective,
    ScrollIntoViewDirective,
    OverflowDetectDirective,
    IFRameDocumentWriteDirective,
    PdfPreviewFromUrlDirective,
    BlinkDirective,
    HtmlContentDirective,
    DraggableInteractDirective,
    TooltipDirective,
    TemplateDirective,
    PdfThumbnailDirective,
    HostListenerDirective,
    UppyDirective,
    ResizeObserverDirective
  ],
  exports: [
    FilePondDirective,
    ScrollIntoViewDirective,
    OverflowDetectDirective,
    IFRameDocumentWriteDirective,
    PdfPreviewFromUrlDirective,
    BlinkDirective,
    HtmlContentDirective,
    DraggableInteractDirective,
    TooltipDirective,
    TemplateDirective,
    PdfThumbnailDirective,
    HostListenerDirective,
    UppyDirective,
    ResizeObserverDirective
  ]
})
export class DirectivesModule {}
